import styled from '@emotion/styled';
import { FileReference } from '@kaizenplatform/belfast-entity';
import { Typography } from '@material-ui/core';
import { User } from '@sentry/browser';
import { createElement, FC } from 'react';
import { FormattedDate } from 'react-intl';

import { IssueComment, User as CommentUser } from '../../../../../graphql/generated/graphql';
import { toJSDate } from '../../../../../utility/graphql/datetime';
import { SPACING_UNIT } from '../../../../constant/spacing';
import AvatarWithName from '../../../primitive/AvatarWithName';
import LfToBr from '../../../primitive/LfToBr';
import FileList, { FileListItem } from '../../FileList';

interface Props {
  comment: Pick<IssueComment, 'assetIds' | 'body' | 'createdAt'> & {
    user: Pick<CommentUser, 'name' | 'profileImageUrl'>;
  };
  files: Array<FileReference>;
  className?: string;
}

const ModificationRequestIssueCommentItem: FC<Props> = ({ comment, files, className }) => {
  const fileItems = comment.assetIds.map((id) => files.filter((file) => file.id === id)).flatMap((value) => value);

  return (
    <div className={className}>
      <User imageUrl={comment.user.profileImageUrl} name={comment.user.name} />

      <Comment variant="subtitle1" component="p">
        <LfToBr text={comment.body} />
      </Comment>

      {fileItems ? (
        <FileList>
          {[
            ...fileItems.map((file) => (
              <FileListItem file={file} key={`issue-file-${file.id}`} isVisibleSecondary={false} />
            )),
          ]}
        </FileList>
      ) : null}

      <Typography variant="body1" color="textSecondary">
        <FormattedDate
          value={toJSDate(comment.createdAt)}
          year="numeric"
          month="2-digit"
          day="2-digit"
          hour="2-digit"
          minute="2-digit"
        />
      </Typography>
    </div>
  );
};

const User = styled(AvatarWithName)({
  marginBottom: SPACING_UNIT,
});

const Comment = (styled(Typography)({
  wordBreak: 'break-word',
  hyphens: 'auto',
}) as unknown) as typeof Typography;

export default ModificationRequestIssueCommentItem;
